module.exports = __webpack_public_path__ + "static/media/logo_pgbank.465204b6.svg";